import React, { useCallback, useEffect, useMemo, useState } from 'react';

/**
 * "Plan ne diyordu, ay içinde ne oldu" bölümü — Eylül 2026 HUPALUPA grubu
 * medya planı sayfalarının dördü de bunu kullanıyor.
 *
 * Veri CANLI: `/api/group/hupalupa/gerceklesen` mecralardan kampanya
 * seviyesinde okur, hiçbir yere yazmaz. Sayfanın geri kalanındaki plan
 * rakamları dondurulmuş sabitlerdir; buradaki rakamlar her açılışta değişir —
 * ikisi bilerek farklı doğada, o yüzden ayrı bir bölümde duruyorlar.
 *
 * 🔑🔑 Plan satırları ile gerçek kampanyalar BİREBİR eşleşmez. Plandaki
 * "Arama, lokasyon kelimeleri" henüz açılmamış olabilir, hesapta plan yazılırken
 * olmayan bir kampanya dönüyor olabilir. Bu yüzden eşleştirme MECRA (ve Store'da
 * marka silosu) seviyesinde yapılır; kampanya listesi eşleştirilmeden, olduğu
 * gibi basılır. Satır satır sahte bir eşleşme kurmak plandan daha yanlış olurdu.
 *
 * 🔑 Varsayılan aralık ayın 1'i → DÜN. Bugün yarım gündür; ay sonu projeksiyonu
 * gün oranına bölerek çalıştığı için yarım günü katmak "plandan geri kaldık"
 * diye okunan sahte bir düşüş üretiyor. "Bugünü de kat" düğmesi isteyene bırakıldı.
 *
 * 🔴 Ciro MECRA BEYANIDIR ve çift sayım içerir: aynı satışı Google da Meta da
 * kendine yazar. Yalnızca `kpi='revenue'` markada (Store) gösterilir ve kartta
 * bu uyarı yazılıdır. Tek sayımlı ciro GA4'tedir, bu uçta yoktur.
 *
 * 🔴 UI metinlerinde emoji YOK — panelin Chromium'unda emoji fontu olmadığı
 * için ekran görüntüsü ve PDF çıktısında kutu (tofu) basıyor.
 */

const API_BASE = (() => {
  const raw = (process.env.REACT_APP_API_URL || 'https://api.glowytics.com').trim();
  return raw.replace(/\/+$/, '').replace(/\/api$/, '');
})();

const MECRA = {
  GOOGLE_ADS: { ad: 'Google Ads', logo: '/google_ads-512.webp' },
  META_ADS: { ad: 'Meta Ads', logo: '/6033716.png' },
  TIKTOK_ADS: { ad: 'TikTok Ads', logo: '/tiktokv4.svg' },
};
const MECRA_SIRA = ['GOOGLE_ADS', 'META_ADS', 'TIKTOK_ADS'];

const AY_ADLARI = [
  'Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran',
  'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık',
];

const tl = (v) => `₺${Math.round(Number(v) || 0).toLocaleString('tr-TR')}`;
const kurus = (v) =>
  `₺${(Number(v) || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const say = (v) => (Number(v) || 0).toLocaleString('tr-TR');
const yuzde = (v, basamak = 0) =>
  v == null || !Number.isFinite(v) ? '—' : `%${(v * 100).toFixed(basamak).replace('.', ',')}`;

/** "2026-09-08" → "8 Eylül" */
function gunEtiketi(iso) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(String(iso || ''))) return iso || '';
  const [, ay, gun] = iso.split('-');
  return `${Number(gun)} ${AY_ADLARI[Number(ay) - 1]}`;
}

/** Bugünün yerel tarihi; `until` üst sınırı için. */
function bugunIso() {
  const d = new Date();
  const p = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

/**
 * Gerçekleşmenin plana göre durumu. Eşik ±%10: bunun altındaki sapma ay içinde
 * gün kaymasıyla (hafta sonu, onay bekleyen kreatif) kapanıyor, renk vermeye
 * değmiyor.
 */
function durum(gercek, beklenen) {
  if (!beklenen) return gercek > 0 ? 'fazla' : 'yok';
  const o = gercek / beklenen;
  if (o < 0.9) return 'geri';
  if (o > 1.1) return 'fazla';
  return 'uyumlu';
}

const DURUM_STIL = {
  uyumlu: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  geri: 'bg-amber-50 text-amber-700 border-amber-200',
  fazla: 'bg-rose-50 text-rose-700 border-rose-200',
  yok: 'bg-gray-50 text-gray-500 border-gray-200',
};
const DURUM_METNI = {
  uyumlu: 'gün oranında',
  geri: 'gün oranının altında',
  fazla: 'gün oranının üstünde',
  yok: 'harcama yok',
};

function Rozet({ tip }) {
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-md border text-[11px] font-medium whitespace-nowrap ${DURUM_STIL[tip]}`}>
      {DURUM_METNI[tip]}
    </span>
  );
}

/** Tek hue; renk kimlik değil BÜYÜKLÜK taşıyor (plan sayfalarındaki kuralla aynı). */
function Cubuk({ oran }) {
  const g = Math.max(0, Math.min(1.5, Number(oran) || 0));
  return (
    <div className="h-1.5 w-full rounded-full bg-slate-100 overflow-hidden">
      <div
        className="h-full rounded-full"
        style={{ width: `${(g / 1.5) * 100}%`, background: g > 1.1 ? '#c2410c' : '#2a78d6' }}
      />
    </div>
  );
}

/** KPI'a göre "sonuç" sütunu; ortak bir sonuç sütunu üç markada 0 yazardı. */
function sonucAlani(kpi) {
  if (kpi === 'lead') return { alan: 'leads', etiket: 'Form' };
  if (kpi === 'conversation') return { alan: 'conversations', etiket: 'Mesaj' };
  if (kpi === 'revenue') return { alan: 'purchases', etiket: 'Satış' };
  return null;   // reach → sonuç sütunu yok, gösterim zaten tabloda
}

export default function EylulGerceklesen({
  brandId,
  plan = {},
  silolar = null,
  kpi = 'revenue',
  planToplam = null,
  notlar = null,
}) {
  const [veri, setVeri] = useState(null);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [hata, setHata] = useState(null);
  const [bugunKat, setBugunKat] = useState(false);
  const [kampanyaAcik, setKampanyaAcik] = useState(false);

  const getir = useCallback(async (yenile = false) => {
    setYukleniyor(true);
    setHata(null);
    try {
      const qs = new URLSearchParams({ brand: brandId });
      if (bugunKat) qs.set('until', bugunIso());
      if (yenile) qs.set('refresh', '1');
      const res = await fetch(`${API_BASE}/api/group/hupalupa/gerceklesen?${qs}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        credentials: 'include',
      });
      const json = await res.json();
      if (!res.ok || !json.ok) throw new Error(json.error || `HTTP ${res.status}`);
      setVeri(json);
    } catch (e) {
      setHata(e.message);
    } finally {
      setYukleniyor(false);
    }
  }, [brandId, bugunKat]);

  useEffect(() => { getir(false); }, [getir]);

  const marka = veri?.brands?.[0] || null;
  const aralik = veri?.range || null;
  const oran = aralik?.oran || null;

  const planToplami = useMemo(
    () => (planToplam != null ? planToplam : Object.values(plan).reduce((a, b) => a + (b || 0), 0)),
    [plan, planToplam]
  );

  /* Silo dağılımı yalnızca Store'da var: kampanya ADINDAN markaya yazılır.
     🔑 Sıra önemli — önce desenli silolar denenir, hiçbirine uymayan kampanya
     `varsayilan: true` olan siloya (Store geneli) düşer. Varsayılan silo
     tanımlanmamışsa ayrı bir "silo dışı" satırı açılır; kampanyalar sessizce
     kaybolmasın. */
  const siloSatirlari = useMemo(() => {
    if (!silolar || !marka) return null;
    const kova = silolar.map((s) => ({ ...s, gercek: 0, kampanya: 0 }));
    const varsayilan = kova.find((s) => s.varsayilan) || null;
    const artik = { etiket: 'Silo dışı', butce: null, gercek: 0, kampanya: 0 };
    for (const k of marka.campaigns) {
      const hit = kova.find((s) => !s.varsayilan && s.desen && s.desen.test(k.name));
      const hedef = hit || varsayilan || artik;
      hedef.gercek += k.spend;
      hedef.kampanya += 1;
    }
    return [...kova, ...(artik.kampanya ? [artik] : [])];
  }, [silolar, marka]);

  const sonuc = sonucAlani(kpi);

  return (
    <div className="rounded-xl border overflow-hidden mb-8">
      <div className="bg-slate-100 px-4 py-3 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="font-semibold text-gray-800">Eylül gerçekleşen — plan nerede duruyor</p>
          <p className="text-[11px] text-gray-600 mt-0.5">
            {aralik
              ? `${gunEtiketi(aralik.since)} - ${gunEtiketi(aralik.until)} · ayın ${aralik.gun}. günü / ${aralik.ayGun} · mecralardan canlı okundu`
              : 'Mecralardan canlı okunuyor'}
          </p>
        </div>
        <div className="flex items-center gap-2">
          {/* Dört planın durumunu yan yana gösteren üst ekran */}
          <a
            href="/budget/hupalupa-eylul-2026-durum"
            className="px-2.5 py-1 rounded-md border border-gray-300 bg-white text-[11px] font-medium text-blue-700 hover:bg-gray-50"
          >
            Dört planın durumu
          </a>
          <button
            type="button"
            onClick={() => setBugunKat((v) => !v)}
            className={`px-2.5 py-1 rounded-md border text-[11px] font-medium ${
              bugunKat ? 'bg-gray-800 text-white border-gray-800' : 'bg-white text-gray-700 border-gray-300'
            }`}
          >
            Bugünü de kat
          </button>
          <button
            type="button"
            onClick={() => getir(true)}
            disabled={yukleniyor}
            className="px-2.5 py-1 rounded-md border border-gray-300 bg-white text-[11px] font-medium text-gray-700 disabled:opacity-50"
          >
            {yukleniyor ? 'Okunuyor...' : 'Yenile'}
          </button>
        </div>
      </div>

      {hata && (
        <div className="px-4 py-3 bg-rose-50 border-b border-rose-200 text-[12px] text-rose-800">
          Gerçekleşen veri okunamadı: {hata}
        </div>
      )}

      {!marka && yukleniyor && (
        <div className="px-4 py-8 text-center text-[12px] text-gray-500">
          Google, Meta ve TikTok hesapları okunuyor...
        </div>
      )}

      {marka && (
        <>
          {/* Dört rakamlık üst şerit */}
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 p-4 border-b">
            <div className="rounded-lg border border-slate-200 bg-slate-50 p-3">
              <p className="text-[10px] font-medium text-gray-600">Ay planı</p>
              <p className="text-lg font-bold text-gray-800 mt-0.5">{tl(planToplami)}</p>
              <p className="text-[10px] text-gray-500">30 günlük toplam</p>
            </div>
            <div className="rounded-lg border border-slate-200 bg-white p-3">
              <p className="text-[10px] font-medium text-gray-600">Bugüne kadar harcanan</p>
              <p className="text-lg font-bold text-gray-900 mt-0.5">{tl(marka.totals.spend)}</p>
              <p className="text-[10px] text-gray-500">
                planın {yuzde(planToplami ? marka.totals.spend / planToplami : null, 1)}'i
              </p>
            </div>
            <div className="rounded-lg border border-slate-200 bg-white p-3">
              <p className="text-[10px] font-medium text-gray-600">Gün oranına göre beklenen</p>
              <p className="text-lg font-bold text-gray-800 mt-0.5">
                {oran ? tl(planToplami * oran) : '—'}
              </p>
              <p className="text-[10px] text-gray-500">planın {yuzde(oran, 1)}'i</p>
            </div>
            <div className="rounded-lg border border-slate-200 bg-white p-3">
              <p className="text-[10px] font-medium text-gray-600">Bu hızla ay sonu</p>
              <p className="text-lg font-bold text-gray-800 mt-0.5">
                {oran ? tl(marka.totals.spend / oran) : '—'}
              </p>
              <p className="text-[10px] text-gray-500">
                {oran && planToplami
                  ? `plana göre ${marka.totals.spend / oran >= planToplami ? '+' : '−'}${tl(
                      Math.abs(marka.totals.spend / oran - planToplami)
                    )}`
                  : '—'}
              </p>
            </div>
          </div>

          {/* Mecra tablosu — planla eşleşmenin yapıldığı yer */}
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 py-2.5 text-left text-[11px] font-medium text-gray-500 uppercase tracking-wider">Mecra</th>
                  <th className="px-4 py-2.5 text-right text-[11px] font-medium text-gray-500 uppercase tracking-wider">Ay planı</th>
                  <th className="px-4 py-2.5 text-right text-[11px] font-medium text-gray-500 uppercase tracking-wider">Gerçekleşen</th>
                  <th className="px-4 py-2.5 text-right text-[11px] font-medium text-gray-500 uppercase tracking-wider">Beklenen</th>
                  <th className="px-4 py-2.5 text-left text-[11px] font-medium text-gray-500 uppercase tracking-wider">Plana göre</th>
                  <th className="px-4 py-2.5 text-right text-[11px] font-medium text-gray-500 uppercase tracking-wider">Bu hızla ay sonu</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-100 text-[12px] text-gray-700">
                {MECRA_SIRA.filter((m) => plan[m] != null || marka.channels[m]).map((m) => {
                  const p = plan[m] || 0;
                  const g = marka.channels[m]?.spend || 0;
                  const beklenen = oran ? p * oran : null;
                  return (
                    <tr key={m} className="hover:bg-gray-50">
                      <td className="px-4 py-3">
                        <div className="flex items-center gap-2">
                          <img src={MECRA[m].logo} alt={MECRA[m].ad} className="w-4 h-4 object-contain" />
                          <span className="font-medium">{MECRA[m].ad}</span>
                          <span className="text-[10px] text-gray-400">
                            {marka.channels[m]?.campaigns || 0} kampanya
                          </span>
                        </div>
                      </td>
                      <td className="px-4 py-3 text-right">{p ? tl(p) : '—'}</td>
                      <td className="px-4 py-3 text-right font-semibold text-gray-900">{tl(g)}</td>
                      <td className="px-4 py-3 text-right text-gray-500">{beklenen ? tl(beklenen) : '—'}</td>
                      <td className="px-4 py-3">
                        <div className="flex flex-col gap-1.5">
                          <Rozet tip={durum(g, beklenen)} />
                          <Cubuk oran={beklenen ? g / beklenen : 0} />
                        </div>
                      </td>
                      <td className="px-4 py-3 text-right">{oran ? tl(g / oran) : '—'}</td>
                    </tr>
                  );
                })}
                <tr className="bg-gray-800 text-white font-bold">
                  <td className="px-4 py-3">TOPLAM</td>
                  <td className="px-4 py-3 text-right">{tl(planToplami)}</td>
                  <td className="px-4 py-3 text-right">{tl(marka.totals.spend)}</td>
                  <td className="px-4 py-3 text-right">{oran ? tl(planToplami * oran) : '—'}</td>
                  <td className="px-4 py-3 text-[11px] font-medium">
                    {yuzde(oran && planToplami ? marka.totals.spend / (planToplami * oran) : null, 0)}
                  </td>
                  <td className="px-4 py-3 text-right">{oran ? tl(marka.totals.spend / oran) : '—'}</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Sonuç şeridi — markanın KPI'ına göre */}
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 p-4 border-t bg-slate-50">
            <div>
              <p className="text-[10px] font-medium text-gray-600">Gösterim</p>
              <p className="text-base font-bold text-gray-800">{say(marka.totals.impressions)}</p>
            </div>
            <div>
              <p className="text-[10px] font-medium text-gray-600">Tıklama</p>
              <p className="text-base font-bold text-gray-800">
                {say(marka.totals.clicks)}
                <span className="ml-1 text-[10px] font-normal text-gray-500">
                  {marka.totals.clicks ? `CPC ${kurus(marka.totals.spend / marka.totals.clicks)}` : ''}
                </span>
              </p>
            </div>
            {sonuc && (
              <div>
                <p className="text-[10px] font-medium text-gray-600">{sonuc.etiket}</p>
                <p className="text-base font-bold text-gray-800">
                  {say(marka.totals[sonuc.alan])}
                  <span className="ml-1 text-[10px] font-normal text-gray-500">
                    {marka.totals[sonuc.alan]
                      ? `adet ${kurus(marka.totals.spend / marka.totals[sonuc.alan])}`
                      : ''}
                  </span>
                </p>
              </div>
            )}
            {kpi === 'revenue' && (
              <div>
                <p className="text-[10px] font-medium text-gray-600">Mecra beyanı ciro</p>
                <p className="text-base font-bold text-gray-800">
                  {tl(marka.totals.conversionValue)}
                  <span className="ml-1 text-[10px] font-normal text-gray-500">
                    {marka.totals.spend
                      ? `ROAS ${(marka.totals.conversionValue / marka.totals.spend).toFixed(2).replace('.', ',')}`
                      : ''}
                  </span>
                </p>
              </div>
            )}
            {kpi === 'reach' && (
              <div>
                <p className="text-[10px] font-medium text-gray-600">Video izlenme</p>
                <p className="text-base font-bold text-gray-800">{say(marka.totals.views)}</p>
              </div>
            )}
          </div>

          {/* Store'da ikinci eşleşme düzlemi: marka silosu */}
          {siloSatirlari && (
            <div className="border-t">
              <div className="bg-slate-100 px-4 py-2.5 text-xs font-semibold text-gray-800">
                Marka silosu bazında — kampanya adından ayrıştırıldı
              </div>
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-4 py-2.5 text-left text-[11px] font-medium text-gray-500 uppercase tracking-wider">Kalem</th>
                      <th className="px-4 py-2.5 text-right text-[11px] font-medium text-gray-500 uppercase tracking-wider">Ay planı</th>
                      <th className="px-4 py-2.5 text-right text-[11px] font-medium text-gray-500 uppercase tracking-wider">Gerçekleşen</th>
                      <th className="px-4 py-2.5 text-right text-[11px] font-medium text-gray-500 uppercase tracking-wider">Beklenen</th>
                      <th className="px-4 py-2.5 text-left text-[11px] font-medium text-gray-500 uppercase tracking-wider">Plana göre</th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-100 text-[12px] text-gray-700">
                    {siloSatirlari.map((s) => {
                      const beklenen = s.butce != null && oran ? s.butce * oran : null;
                      return (
                        <tr key={s.etiket} className="hover:bg-gray-50">
                          <td className="px-4 py-2.5">
                            <span className="font-medium">{s.etiket}</span>
                            <span className="ml-2 text-[10px] text-gray-400">{s.kampanya} kampanya</span>
                          </td>
                          <td className="px-4 py-2.5 text-right">{s.butce != null ? tl(s.butce) : '—'}</td>
                          <td className="px-4 py-2.5 text-right font-semibold text-gray-900">{tl(s.gercek)}</td>
                          <td className="px-4 py-2.5 text-right text-gray-500">{beklenen ? tl(beklenen) : '—'}</td>
                          <td className="px-4 py-2.5">
                            {beklenen ? (
                              <div className="flex flex-col gap-1.5">
                                <Rozet tip={durum(s.gercek, beklenen)} />
                                <Cubuk oran={s.gercek / beklenen} />
                              </div>
                            ) : (
                              <span className="text-[11px] text-gray-400">planda ayrı kalem yok</span>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* Kampanya listesi — eşleştirilmeden, hesaptaki adıyla */}
          <div className="border-t">
            <button
              type="button"
              onClick={() => setKampanyaAcik((v) => !v)}
              className="w-full bg-slate-100 px-4 py-2.5 text-left text-xs font-semibold text-gray-800 hover:bg-slate-200"
            >
              {kampanyaAcik ? 'Kampanya listesini gizle' : `Hesapta dönen ${marka.campaigns.length} kampanyayı göster`}
            </button>
            {kampanyaAcik && (
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-4 py-2.5 text-left text-[11px] font-medium text-gray-500 uppercase tracking-wider">Mecra</th>
                      <th className="px-4 py-2.5 text-left text-[11px] font-medium text-gray-500 uppercase tracking-wider">Kampanya</th>
                      <th className="px-4 py-2.5 text-right text-[11px] font-medium text-gray-500 uppercase tracking-wider">Harcama</th>
                      <th className="px-4 py-2.5 text-right text-[11px] font-medium text-gray-500 uppercase tracking-wider">Gösterim</th>
                      <th className="px-4 py-2.5 text-right text-[11px] font-medium text-gray-500 uppercase tracking-wider">Tık</th>
                      <th className="px-4 py-2.5 text-right text-[11px] font-medium text-gray-500 uppercase tracking-wider">CPC</th>
                      {sonuc && (
                        <th className="px-4 py-2.5 text-right text-[11px] font-medium text-gray-500 uppercase tracking-wider">{sonuc.etiket}</th>
                      )}
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-100 text-[12px] text-gray-700">
                    {marka.campaigns.map((k) => (
                      <tr key={`${k.platform}-${k.id}`} className="hover:bg-gray-50">
                        <td className="px-4 py-2">
                          <img src={MECRA[k.platform]?.logo} alt={MECRA[k.platform]?.ad} className="w-4 h-4 object-contain" />
                        </td>
                        <td className="px-4 py-2">
                          {k.name}
                          {k.paylasilan && (
                            <span className="ml-2 text-[10px] text-gray-400">paylaşılan hesaptan</span>
                          )}
                        </td>
                        <td className="px-4 py-2 text-right font-medium">{tl(k.spend)}</td>
                        <td className="px-4 py-2 text-right">{say(k.impressions)}</td>
                        <td className="px-4 py-2 text-right">{say(k.clicks)}</td>
                        <td className="px-4 py-2 text-right">{k.clicks ? kurus(k.spend / k.clicks) : '—'}</td>
                        {sonuc && <td className="px-4 py-2 text-right">{say(k[sonuc.alan])}</td>}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>

          {marka.errors?.length > 0 && (
            <div className="px-4 py-2.5 bg-amber-50 border-t border-amber-200 text-[11px] text-amber-800">
              Uyarı: {marka.errors.map((e) => `${e.account} (${e.error})`).join(' · ')} okunamadı;
              yukarıdaki toplamlar bu hesap olmadan hesaplandı.
            </div>
          )}

          <div className="px-4 py-2.5 bg-slate-50 border-t border-slate-200 text-[11px] text-gray-700 leading-relaxed">
            Rakamlar Google Ads, Meta ve TikTok hesaplarından kampanya seviyesinde canlı okunur, hiçbir
            yere yazılmaz. "Beklenen", ay planının geçen gün sayısına düşen payıdır; bütçe her güne eşit
            dağıtılsaydı bugüne kadar yanmış olması gereken tutar. "Bu hızla ay sonu" aynı hızın 30 güne
            uzatılmasıdır, taahhüt değildir.
            {kpi === 'revenue' && ' Ciro mecranın kendi beyanıdır ve çift sayım içerir: aynı satışı Google da Meta da kendine yazar; tek sayımlı ciro GA4 tarafındadır.'}
            {notlar ? ` ${notlar}` : ''}
          </div>
        </>
      )}
    </div>
  );
}
